import { render, staticRenderFns } from "./AttachmentBrowser.yaml?vue&type=template&id=54dde17e&component"
import script from "./AttachmentBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./AttachmentBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports